$(document).ready(() => {
    const $featuredLoadMore = $('#js-load-featured-articles');
    const $featuredLoadLess = $('#js-hide-featured-articles');
    const $featuredLoadMoreList = $('.js-blog_featured-hidden');

    $featuredLoadMore.on('click', (e) => {
        e.preventDefault();
        $featuredLoadMore.addClass('hidden');
        $featuredLoadMoreList.addClass('visible');
        $featuredLoadLess.addClass('visible');
    });

    $featuredLoadLess.on('click', (e) => {
        e.preventDefault();
        $featuredLoadMore.removeClass('hidden');
        $featuredLoadMoreList.removeClass('visible');
        $featuredLoadLess.removeClass('visible');
    });
});
